import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

// Public-facing trial length for signup/landing copy.
//
// The single source of trial length is platform_settings.trial_default_days, but that
// table is authenticated-only. subscription_plans.trial_days IS anon-readable and is
// kept in sync with the global by the mig-303 propagation trigger, so any active plan's
// value reflects the owner's configured trial. Reading it here means the public copy
// follows the ONE field without a new anon read path on platform_settings.
// Falls back to 14 (matches the server-side get_trial_days() default) while loading.
export function useTrialDays(): number {
  const [days, setDays] = useState(14)

  useEffect(() => {
    supabase
      .from('subscription_plans')
      .select('trial_days')
      .eq('is_active', true)
      .order('sort_order', { ascending: true })
      .limit(1)
      .then(({ data }) => {
        const v = (data as { trial_days: number }[] | null)?.[0]?.trial_days
        if (typeof v === 'number' && v > 0) setDays(v)
      })
  }, [])

  return days
}
